import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/table';

// Shared by the full guide and contextual help so their instructions stay identical.
export default function GuideTopicBody({ topic, compact = false }) {
  return <div className={`guide-topic-body${compact ? ' guide-topic-body--compact' : ''}`}>
    <p className="guide-summary">{topic.summary}</p>
    {topic.steps?.length > 0 && <ol className="guide-steps">{topic.steps.map((step, i) => <li key={i}>{step}</li>)}</ol>}
    {topic.table && <Table><TableHeader><TableRow>{topic.table.headers.map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader><TableBody>{topic.table.rows.map((row, i) => <TableRow key={i}>{row.map((cell, j) => <TableCell key={j}>{cell}</TableCell>)}</TableRow>)}</TableBody></Table>}
    {topic.notes?.length > 0 && <div className="guide-notes"><h3>À retenir</h3><ul>{topic.notes.map((note, i) => <li key={i}>{note}</li>)}</ul></div>}
    {topic.warnings?.map((warning, i) => <div className="notice notice--warning" key={i}>{warning}</div>)}
  </div>;
}
